import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'jsg-sticky-action-toolbar',
  templateUrl: './sticky-action-toolbar.component.html',
  styleUrls: ['./sticky-action-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyActionToolbarComponent implements OnInit {
  @Input() actionNumber: string;
  @Input() styleOfCause: string;
  @Input() civilMatterType: string;
  @Input() actionButtonText: string;
  @Input() showViewLink: boolean = false;
  @Input() showJoinAction: boolean = false;

  @Output() action = new EventEmitter();
  @Output() joinAction = new EventEmitter();
  @Output() view: EventEmitter<string> = new EventEmitter<string>();



  // private scrollListener;

  // @ViewChild('sidenav', { static: false }) _sn: ElementRef;

  constructor(private renderer: Renderer2, private _cd: ChangeDetectorRef) {
    //   this.scrollListener = this.renderer.listen('window', 'scroll', (e) => {
    //     var isPositionFixed =
    //       window.getComputedStyle(this._sn.nativeElement).position == 'fixed';
    //     if (window.scrollY > 94 && !isPositionFixed) {
    //       this.renderer.setStyle(this._sn.nativeElement, 'position', 'fixed');
    //       this.renderer.setStyle(this._sn.nativeElement, 'top', '0px');
    //       this.renderer.setStyle(this._sn.nativeElement, 'width', '100%');
    //       //this._sn.nativeElement.style.({ position: 'fixed', top: '0px' });
    //     }
    //     if (window.scrollY < 94 && isPositionFixed) {
    //       this.renderer.setStyle(this._sn.nativeElement, 'position', 'unset');
    //       this.renderer.setStyle(this._sn.nativeElement, 'top', '0px');
    //     }
    //     this._cd.markForCheck();
    //     this._cd.detectChanges();
    //   });
    // }
  }
  ngOnInit(): void {
    // if (this.showViewLink && !this.actionId)
    //   console.error('Action Id is required when view link is enabled');
  }

  joinActionClick(){

    this.joinAction.emit();
  }
}
